import { render, staticRenderFns } from "./OfficeItem.vue?vue&type=template&id=e5aea590&scoped=true&"
import script from "./OfficeItem.vue?vue&type=script&lang=js&"
export * from "./OfficeItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=e5aea590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aea590",
  null
  
)

export default component.exports